// Mock Firebase sistemi - Android/APK/Emulator için
let app, messaging;

console.log('Mock Firebase sistemi başlatıldı');

// FCM token alma fonksiyonu
export const getFCMToken = async () => {
  try {
    console.log('Mock FCM token oluşturuluyor');
    const mockToken = 'test-fcm-token-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    console.log('Mock FCM Token:', mockToken);
    return mockToken;
  } catch (error) {
    console.error('Mock FCM token alma hatası:', error);
    return null;
  }
};

// Foreground mesaj dinleyici
export const onMessageListener = () => {
  return new Promise((resolve) => {
    console.log('Mock message listener oluşturuldu');
    resolve(null);
  });
};

export { messaging };
